<script>
export default {
    components: {},
    props: {
        title: {
            type: String,
            default: "",
        },
        items: {
            type: Array,
            default: () => {
                return {};
            },
        },
        ctaButtons: {
            type: Array,
            default: () => {
                return [];
            },
        },
    },
};
</script>
<template>
    <!-- start page title -->

    <div class="page-title-box">
        <div class="row">
            <div class="col-md-auto">
                <div class="s1-d-flex link-back">
                    <router-link v-for="cta in ctaButtons" v-bind:key="cta.text" tag="a" :to="{ name: cta.routeName }" class="chevron-border me-2 d-center">
                        <i class="bx bx-chevron-left list-back align-middle"></i>
                    </router-link>
                    <h4 class="me-3 mb-0">{{ title }}</h4>
                </div>
            </div>
            <div class="col-md-auto ms-md-auto">
                <div class="s1-breadcrumb d-none d-md-block">
                    <b-breadcrumb :items="items" class="m-0"> </b-breadcrumb>
                </div>
            </div>
        </div>
    </div>

</template>
